import { useEffect, useRef } from "react";

const RulesModal = ({ text, closeModal }) => {
   const modalRef = useRef();

   useEffect(() => {
      const close = (e) => {
         if (modalRef.current && !modalRef.current.contains(e.target)) {
            closeModal();
         }
      };
      document.body.addEventListener("click", close, true);
      return () => document.body.removeEventListener("click", close);
   }, []);

   return (
      <div className="legal__modal">
         <div className="legal__modal-content" ref={modalRef}>
            <img src="/img/plus.svg" onClick={closeModal} />
            <pre>{text}</pre>
         </div>
      </div>
   );
};

export default RulesModal;